import { TAG_TYPES } from '../../../../Shared/constants/commonConstants';
import {
  DETAILED_BOOKING_SOV_FIELDS, TYPE_OF_PURCHASE
} from '../constants/DetailedBookingConstants';
import { GP_SLOT_FIELD } from '../constants/FormFieldsConstants';
import {
  DetailedBookingSOVData, DetailedBookingSOVPartialDataErrors, SlotOptionType
} from '../interface/DetailedBookingInterface';
import { COMMON_FIELD_ID_ARRAY, COMMON_FIELD_IDS } from './detailedFormFieldsConfig';

export const createDetailedBookingSOVFormConfig = (
  formData: DetailedBookingSOVData,
  handleInputChange: (field: string, value: string) => void,
  isContextualSelected: boolean,
  fieldErrors: DetailedBookingSOVPartialDataErrors,
  slotOptions: SlotOptionType[] = [],
  isLoadingSlots: boolean = false,
  hideCommonFields: boolean = false
) => {
  const hasGpSlotSelected = formData.gpSlot && formData.gpSlot.trim() !== '';

  const allFields = [
    {
      id: COMMON_FIELD_IDS.ENTRY_NUMBER_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'entry-number-label',
      value: formData.entryNumber,
      placeholder: 'entry-number-placeholder',
      disabled: true,
      error: fieldErrors.entryNumber,
    },
    {
      id: COMMON_FIELD_IDS.BRAND_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'brand-label',
      value: formData.brand,
      placeholder: 'brand-placeholder',
      disabled: true,
      error: '',
    },
    {
      id: COMMON_FIELD_IDS.AE_NAME_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'ae-name-label',
      value: formData.aeName,
      placeholder: 'ae-name-placeholder',
      disabled: true,
      error: '',
    },
    {
      id: COMMON_FIELD_IDS.CATEGORY_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'category-label',
      value: formData.category,
      placeholder: 'category-placeholder',
      disabled: true,
      error: '',
    },
    {
      id: COMMON_FIELD_IDS.TYPE_OF_PURCHASE_FIELD,
      type: TAG_TYPES.INPUT_TAG_TYPE,
      label: 'type-of-purchase-label',
      value: formData.typeOfPurchase,
      placeholder: 'type-of-purchase-placeholder',
      disabled: true,
      error: '',
    },
    {
      id: GP_SLOT_FIELD,
      type: TAG_TYPES.DROPDOWN_TAG_TYPE,
      label: 'gp-slot-label',
      value: formData.gpSlot,
      onChange: (value: string) =>
        handleInputChange(DETAILED_BOOKING_SOV_FIELDS.GP_SLOT, value),
      placeholder: 'gp-slot-placeholder',
      options: slotOptions,
      disabled: isLoadingSlots,
      error: fieldErrors.gpSlot,
    },
    ...(hasGpSlotSelected && !isContextualSelected
      ? [
        {
          id: 'sov-percentage-field',
          type: TAG_TYPES.INPUT_TAG_TYPE,
          label: 'sov-percentage-label',
          value: !formData.sovPercentageForGP ? '' : formData.sovPercentageForGP.toString(),
          onChange: (value: string) =>
            handleInputChange(
              DETAILED_BOOKING_SOV_FIELDS.SOV_PERCENTAGE_FOR_GP,
              value
            ),
          placeholder: 'sov-percentage-placeholder',
          error: fieldErrors.sovPercentageForGP,
        },
      ]
      : []
    ),
    ...(hasGpSlotSelected
      ? [
        {
          id: 'value-blocked-field',
          type: TAG_TYPES.INPUT_TAG_TYPE,
          label: 'value-blocked-label',
          value: formData.valueBlockedByLineItem.toString(),
          onChange: (value: string) =>
            handleInputChange(
              DETAILED_BOOKING_SOV_FIELDS.VALUE_BLOCKED_BY_LINE_ITEM,
              value
            ),
          placeholder: 'value-blocked-placeholder',
          disabled: formData.typeOfPurchase === TYPE_OF_PURCHASE.GP_SOV,
          error: fieldErrors.valueBlockedByLineItem,
        },
      ]
      : []
    ),
  ];

  if (hideCommonFields) return allFields.filter((field) => !COMMON_FIELD_ID_ARRAY.includes(field.id));

  return allFields;
};
